export default __webpack_public_path__ + "static/media/ReleaseNotes.48d41fdf.md";